export default "__VITE_ASSET__DEPXE9Pr__"